<template>
  <div>
    <Head title="出貨管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <Dialog :visible.sync="show_delivery_date_selector">
      <template #header>
        <h3>請選擇預計送達日</h3>
      </template>

      <Calendar v-model="delivery_date" :inline="true" />

      <template #footer>
        <Button
          label="確認"
          icon="pi pi-check"
          autofocus
          @click="finish_picking_with_date"
        />
      </template>
    </Dialog>

    <!-- <div class="text-right">
      <FileUpload mode="basic" chooseLabel="上傳全日物流清單" name="file" :url="route('admin.delivery.upload', 'delivery_info_roundday')" :auto="true" @before-send="beforeUpload" accept="application/vnd.ms-excel" invalidFileTypeMessage="{0}：檔案格式錯誤，僅接受Excel格式檔案。"/>
    </div> -->

    <delivery-template>
      <!-- selectionMode="multiple"
        :metaKeySelection="false" -->
      <DataTable
        :loading="isLoading"
        :value="$page.props.orders.data"
        :selection.sync="selectedOrders"
        sortMode="multiple"
        :multiSortMeta.sync="multiSortMeta"
        @sort="onSort($event)"
      >
        <template #header>
          <div class="flex flex-row justify-between items-center">
            <div>
              <SelectButton
                v-model="selectedFilters"
                :options="filterables"
                optionLabel="label"
                optionValue="condition"
                @input="onFilter"
              />
            </div>
            <div class="flex gap-2 justify-around">
              <span
                class="whitespace-nowrap"
                v-if="
                  selectedOrders.filter(
                    (order) => order.delivery_type == 'frozen'
                  ).length
                "
              >
                <span class="delivery_badge bg-fh-delivery-frozen">冷凍</span>
                x
                {{
                  selectedOrders.filter(
                    (order) => order.delivery_type == "frozen"
                  ).length
                }}
              </span>
              <span
                class="whitespace-nowrap"
                v-if="
                  selectedOrders.filter(
                    (order) => order.delivery_type == 'refrigerated'
                  ).length
                "
              >
                <span class="delivery_badge bg-fh-delivery-refrigerated"
                  >冷藏</span
                >
                x
                {{
                  selectedOrders.filter(
                    (order) => order.delivery_type == "refrigerated"
                  ).length
                }}
              </span>
              <span
                class="whitespace-nowrap"
                v-if="
                  selectedOrders.filter(
                    (order) => order.delivery_type == 'normal'
                  ).length
                "
              >
                <span class="delivery_badge bg-fh-delivery-normal">常溫</span>
                x
                {{
                  selectedOrders.filter(
                    (order) => order.delivery_type == "normal"
                  ).length
                }}
              </span>
            </div>
            <div>
              <template v-if="!decodeURI($page.url).includes('type=')">
                <Button
                  label="進行揀貨"
                  :disabled="selectedOrders.length == 0"
                  @click="start_picking"
                />
              </template>

              <template v-if="decodeURI($page.url).includes('type=picking')">
                <!-- <Button
                  icon="pi pi-print"
                  label="雙單"
                  class="p-button-outlined"
                  :disabled="selectedOrders.length == 0"
                  @click="print('picking_and_packing_list')"
                /> -->
                <Button
                  icon="pi pi-print"
                  label="出貨單"
                  class="p-button-outlined"
                  :disabled="selectedOrders.length == 0"
                  @click="print('packing_list')"
                />
                <Button
                  icon="pi pi-print"
                  label="揀貨單"
                  class="p-button-outlined"
                  :disabled="selectedOrders.length == 0"
                  @click="print('picking_list')"
                />
                <Button
                  label="揀貨完成"
                  :disabled="
                    selectedOrders.length == 0 ||
                    selectedOrders.some((order) => {
                      return order.method == 'regular';
                    })
                  "
                  @click="finish_picking"
                />
              </template>

              <template v-if="decodeURI($page.url).includes('type=packing')">
                <Button
                  icon="pi pi-calendar"
                  label="調整日期"
                  :disabled="selectedOrders.length == 0"
                  @click="finish_picking()"
                />
                <Button
                  label="出貨完成"
                  :disabled="selectedOrders.length == 0"
                  @click="shipped"
                />
              </template>
            </div>
          </div>
          <div
            class="mt-1 flex flex-row justify-between items-center"
            v-if="decodeURI($page.url).includes('type=packing')"
          >
            <div>
              <SelectButton
                v-model="selectedFilters"
                :options="delivery_filterables"
                optionLabel="label"
                optionValue="condition"
                @input="onFilter"
              />
            </div>
            <div>
              <Button
                icon="pi pi-chevron-down"
                iconPos="right"
                label="列印貨運單"
                @click="toggleDeliveryInfoOptions"
                :disabled="selectedOrders.length == 0"
              />
            </div>
          </div>
        </template>

        <Column headerClass="w-11" selectionMode="multiple"></Column>

        <Column field="order_subno" header="訂單編號" sortable></Column>

        <Column field="delivery_type" header="溫層" sortable>
          <template #body="slotProps">
            <template v-if="slotProps.data.delivery_type == 'frozen'"
              ><span class="delivery_badge bg-fh-delivery-frozen"
                >冷凍</span
              ></template
            >
            <template v-else-if="slotProps.data.delivery_type == 'refrigerated'"
              ><span class="delivery_badge bg-fh-delivery-refrigerated"
                >冷藏</span
              ></template
            >
            <template v-else-if="slotProps.data.delivery_type == 'normal'"
              ><span class="delivery_badge bg-fh-delivery-normal"
                >常溫</span
              ></template
            >
            <template v-else>{{ slotProps.data.delivery_type }}</template>
          </template>
        </Column>

        <Column
          v-if="!decodeURI($page.url).includes('type=')"
          field="counts"
          header="種類"
          sortable
        ></Column>

        <Column
          v-if="!decodeURI($page.url).includes('type=')"
          field="quantities"
          header="件數"
          sortable
        ></Column>

        <Column
          v-if="decodeURI($page.url).includes('type=picking')"
          field="pick_printed_by"
          header="揀貨人"
          sortable
        >
          <template #body="slotProps">
            {{ slotProps.data.pick_printed_by?.name ?? "-" }}
          </template>
        </Column>

        <Column
          v-if="decodeURI($page.url).includes('type=packing')"
          field="pack_printed_by"
          header="揀貨人"
          sortable
        >
          <template #body="slotProps">
            {{ slotProps.data.pack_printed_by?.name ?? "-" }}
          </template>
        </Column>

        <Column
          v-if="decodeURI($page.url).includes('type=picking')"
          field="pick_printed_at"
          header="開始時間"
          sortable
        >
          <template #body="slotProps">
            {{ dayjs(slotProps.data.pick_printed_at).fromNow() }}
          </template>
        </Column>

        <Column header="方式">
          <template
            v-if="decodeURI($page.url).includes('type=picking')"
            #body="slotProps"
          >
            <div
              v-if="
                delivery_methods.some((method) => {
                  return (
                    method.value == slotProps.data.method ||
                    slotProps.data.method == 'regular'
                  );
                })
              "
            >
              <Dropdown
                placeholder="宅配…"
                class="w-32"
                v-model="slotProps.data.method"
                :options="delivery_methods"
                optionLabel="label"
                optionValue="value"
              />
            </div>
            <div v-else>
              <template v-if="slotProps.data.method == 'regular'">
                一般物流
              </template>
              <template v-else-if="slotProps.data.method == 'roundday'">
                全日
              </template>
              <template v-else-if="slotProps.data.method == 'suda'">
                黑貓
              </template>
              <template v-else-if="slotProps.data.method == '711'">
                7-11店到店
              </template>
              <template v-else-if="slotProps.data.method == '711_pay'">
                7-11貨到付款
              </template>
              <template v-else> 其他 </template>
            </div>
          </template>
          <template v-else #body="slotProps">
            <template v-if="slotProps.data.method == 'regular'">
              一般物流
            </template>
            <template v-else-if="slotProps.data.method == 'roundday'">
              全日
            </template>
            <template v-else-if="slotProps.data.method == 'suda'">
              黑貓
            </template>
            <template v-else-if="slotProps.data.method == '711'">
              7-11店到店
            </template>
            <template v-else-if="slotProps.data.method == '711_pay'">
              7-11貨到付款
            </template>
            <template v-else> 其他 </template>
          </template>
        </Column>

        <Column
          v-if="decodeURI($page.url).includes('type=picking')"
          header="箱體尺寸"
          bodyClass="w-24"
        >
          <template #body="slotProps">
            <template
              v-if="
                slotProps.data.method == 'regular' ||
                slotProps.data.method == 'suda' ||
                slotProps.data.method == 'roundday'
              "
            >
              <Dropdown
                class="w-24"
                v-model="slotProps.data.box_size"
                :options="box_sizes"
                optionLabel="label"
                optionValue="value"
              />

              <!-- <SelectButton
              v-model="slotProps.data.box_size"
              :options="box_sizes"
              optionLabel="label"
              optionValue="value"
            /> -->
            </template>
            <template
              v-else-if="
                slotProps.data.method == '711' ||
                slotProps.data.method == '711_pay'
              "
            >
              <i
                class="pi pi-info-circle"
                v-tooltip.left="
                  '一般材積寄件：\r\n材積最長邊≦ 45cm；\r\n長＋寬＋高合計≦105cm；\r\n重量≦ 5kg。\r\n寄件外箱(袋)若有舊標籤請務必撕除，確保包裹可順利送達。'
                "
              ></i>
            </template>
            <template v-else> （不適用） </template>
          </template>
        </Column>

        <Column
          v-if="decodeURI($page.url).includes('type=packing')"
          field="pack_printed_at"
          header="完成時間"
          sortable
        >
          <template #body="slotProps">
            {{ dayjs(slotProps.data.pack_printed_at).fromNow() }}
          </template>
        </Column>

        <Column field="summary" v-if="!decodeURI($page.url).includes('type=')">
        </Column>

        <Column field="summary" v-if="decodeURI($page.url).includes('type=')">
          <template #body="slotProps">
            <i
              class="pi pi-list"
              v-tooltip.left="
                slotProps.data.summary
                  .split(',')
                  .map((item, index) => ' · ' + item)
                  .join('\r\n')
              "
            />
          </template>
        </Column>

        <template #empty>沒有任何符合條件的未處理訂單。</template>
      </DataTable>
      <OverlayPanel ref="delivery_info_options" :dismissable="true">
        <Button
          icon="pi pi-external-link"
          label="（7-11）繳費單（常溫）"
          class="p-button-outlined"
          v-if="
            selectedOrders.some((order) => {
              return (
                (order.method == '711' || order.method == '711_pay') &&
                order.delivery_type == 'normal'
              );
            })
          "
          @click="open_new_window('delivery_info_711')"
        />
        <Button
          icon="pi pi-external-link"
          label="（7-11）繳費單（冷凍）"
          class="p-button-outlined"
          v-if="
            selectedOrders.some((order) => {
              return (
                (order.method == '711' || order.method == '711_pay') &&
                (order.delivery_type == 'frozen' ||
                  order.delivery_type == 'refrigerated')
              );
            })
          "
          @click="open_new_window('delivery_info_711_frozen')"
        />
        <Button
          icon="pi pi-download"
          label="（全日）宅配委託總表"
          class="p-button-outlined"
          v-if="
            selectedOrders.some((order) => {
              return order.method == 'roundday';
            })
          "
          @click="download('delivery_info_roundday')"
        />
        <Button
          icon="pi pi-print"
          label="（黑貓）貨運單"
          class="p-button-outlined"
          v-if="
            selectedOrders.some((order) => {
              return order.method == 'suda';
            })
          "
          @click="print('delivery_info_suda')"
        />
      </OverlayPanel>
    </delivery-template>

    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="$page.props.orders" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import DeliveryTemplate from "./Shared/DeliveryTemplate";
import DataTable from "primevue/datatable";
import Dropdown from "primevue/dropdown";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import OverlayPanel from "primevue/overlaypanel";
import Tag from "primevue/tag";
import SelectButton from "primevue/selectbutton";
import Paginator from "@/Shared/Paginator";
import printJS from "print-js";
import Dialog from "primevue/dialog";
import Calendar from "primevue/calendar";
import FileUpload from "primevue/fileupload";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    DeliveryTemplate,
    DataTable,
    Dropdown,
    Column,
    Button,
    InputText,
    MultiSelect,
    OverlayPanel,
    Tag,
    SelectButton,
    Paginator,
    Dialog,
    Calendar,
    FileUpload,
  },
  layout: Layout,
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "訂單管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      filterables: [
        {
          label: "所有溫層",
          condition: [],
        },
        {
          label: "冷凍",
          condition: [
            {
              field: "delivery_type",
              value: "frozen",
            },
          ],
        },
        {
          label: "冷藏",
          condition: [
            {
              field: "delivery_type",
              value: "refrigerated",
            },
          ],
        },
        {
          label: "常溫",
          condition: [
            {
              field: "delivery_type",
              value: "normal",
            },
          ],
        },
      ],
      delivery_filterables: [
        {
          label: "所有物流",
          condition: [],
        },
        {
          label: "全日",
          condition: [
            {
              field: "method",
              value: "roundday",
            },
          ],
        },
        {
          label: "黑貓",
          condition: [
            {
              field: "method",
              value: "suda",
            },
          ],
        },
        {
          label: "7-11",
          condition: [
            {
              field: "method",
              value: "711",
            },
            {
              field: "method",
              value: "711_pay",
            },
          ],
        },
      ],
      box_sizes: [
        {
          label: "小",
          value: "s",
        },
        {
          label: "中",
          value: "m",
        },
        {
          label: "大",
          value: "l",
        },
        {
          label: "特大",
          value: "xl",
        },
      ],
      delivery_methods: [
        {
          label: "全日",
          value: "roundday",
        },
        {
          label: "黑貓",
          value: "suda",
        },
      ],
      selectedFilters: [],
      selectedOrders: [],
      multiSortMeta: [],
      isLoading: false,
      show_delivery_date_selector: false,
      // show_roundday_excel_uploader: false,
      delivery_date: null,
    };
  },
  methods: {
    print(type) {
      this.isLoading = true;
      axios
        .post(route("admin.delivery.print"), {
          type: type,
          orders: this.selectedOrders.map((order) => {
            return {
              id: order.order_id,
              method: order.method,
              delivery_type: order.delivery_type,
            };
          }),
        })
        .then((response) => {
          if (response.data.successed) {
            printJS(response.data.url);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "API請求發生錯誤",
              detail: response.data.message ?? "沒有提供任何錯誤訊息",
              life: 10000,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    download(type) {
      this.isLoading = true;

      let orders = this.selectedOrders.map((order) => {
        return {
          id: order.order_id,
          method: order.method,
          delivery_type: order.delivery_type,
        };
      });

      window.open(
        route("admin.delivery.download", type) +
          "?orders=" +
          JSON.stringify(orders),
        "_blank"
      );

      this.isLoading = false;
    },
    open_new_window(type) {
      this.isLoading = true;

      let orders = this.selectedOrders.map((order) => {
        return {
          id: order.order_id,
          method: order.method,
          delivery_type: order.delivery_type,
        };
      });

      window.open(
        route("admin.delivery.open_new_window", type) +
          "?orders=" +
          JSON.stringify(orders),
        "_blank"
      );

      this.isLoading = false;
    },
    // beforeUpload(request) {
    //   this.isUploading = true;
    //   request.xhr.setRequestHeader("X-CSRF-TOKEN", this.$page.props.csrf_token);
    //   return request;
    // },
    toggleDeliveryInfoOptions(event) {
      this.$refs.delivery_info_options.toggle(event);
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    onSort(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["orders"],
      });
    },
    onFilter(event) {
      this.selectedOrders = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["orders"],
      });
    },
    start_picking() {
      let picking_list = {
        orders: this.selectedOrders.map((order) => {
          return {
            id: order.order_id,
            method: order.method,
            delivery_type: order.delivery_type,
          };
        }),
      };
      this.$inertia.post(route("admin.delivery.pick"), picking_list, {
        onSuccess: (page) => {
          this.print("picking_and_packing_list");
          this.selectedOrders = [];
          this.$inertia.visit(
            route("admin.delivery") + this.changeType("picking")
          );
        },
      });
    },
    finish_picking() {
      this.delivery_date =
        this.dayjs().add(1, "day").day() == 0
          ? this.dayjs().add(2, "day").toDate()
          : this.dayjs().add(1, "day").toDate();

      this.show_delivery_date_selector = true;
    },
    finish_picking_with_date() {
      this.show_delivery_date_selector = false;
      let packing_list = {
        orders: this.selectedOrders.map((order) => {
          return {
            id: order.order_id,
            method: order.method,
            delivery_type: order.delivery_type,
            box_size: order.box_size,
            delivery_date: this.dayjs(this.delivery_date).format("YYYYMMDD"),
          };
        }),
      };

      this.$inertia.post(route("admin.delivery.pack"), packing_list, {
        onSuccess: (page) => {
          if (
            packing_list.orders.some((list) => {
              return list.method == "suda";
            })
          ) {
            this.print("delivery_info_suda");
          }

          if (
            packing_list.orders.some((list) => {
              return list.method == "roundday";
            })
          ) {
            console.log("roundday");
            // this.print("delivery_info");
          }

          this.selectedOrders = [];
          this.$inertia.visit(
            route("admin.delivery") + this.changeType("packing")
          );
        },
      });
    },
    shipped() {
      this.$inertia.post(route("admin.delivery.processed"), {
        orders: this.selectedOrders.map((order) => {
          return { id: order.order_id, delivery_type: order.delivery_type };
        }),
      });
    },
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    changeType(type) {
      let queryStringArray = this.getQueryStrings();

      if (type != null) {
        queryStringArray["type"] = type;
      } else {
        _.unset(queryStringArray, "type");
      }

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      return "?" + queryStrings.join("&");
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition[0]);
        if (found) {
          if (!_.find(this.selectedFilters, found))
            this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.delivery_badge {
  @apply rounded-full py-0.5 px-2 text-white text-sm items-center my-auto ml-2 whitespace-nowrap;
}
</style>